import { createSelector } from '@reduxjs/toolkit';

import { ValidationStatuses } from '@cashier/cashier-model';

import {
  CONFIRMATION_FORM_FEATURE_KEY,
  ConfirmationFormState,
} from './confirmationForm.slice';

export const getConfirmationFormState = (
  rootState: any,
): ConfirmationFormState => rootState[CONFIRMATION_FORM_FEATURE_KEY];

export const selectConfirmationFormPayload = createSelector(
  getConfirmationFormState,
  (s) => s.formPayload,
);

export const selectConfirmationFormPayloadItem = (fieldName: string) =>
  createSelector(
    getConfirmationFormState,
    (s) =>
      s.formPayload?.[fieldName] || {
        value: null,
        interactionCompleted: true,
        validationStatus: ValidationStatuses.UNDEFINED,
        errors: [],
      },
  );
export const selectConfirmationFormSchema = createSelector(
  getConfirmationFormState,
  (s) => s.formSchema,
);

export const selectConfirmationFormStatus = createSelector(
  getConfirmationFormState,
  (s) => s.status,
);
